import smart_comply_logo_blue from "assets/smartcomply-blue.svg";
import LanguageSwitcher from "components/sections/home/LanguageSwitcher";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import MobileNavbar from "./MobileNavbar";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const EVENT_DATE = new Date("2026-02-26T00:00:00");

const Navbar = () => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0 });

  const pathname = useLocation().pathname;
  const { t } = useTranslation("event");

  const navigate = useNavigate();

  const scrollToSection = (id) => {
    // if (pathname !== "/") {
    //   navigate("/");
    //   setTimeout(() => {
    //     document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    //   }, 100);
    // } else {
    navigate("/breakfast-event");
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    // }
  };

  useEffect(() => {
    const update = () => {
      const now = new Date();
      const diff = EVENT_DATE.getTime() - now.getTime();

      if (diff <= 0) return;

      const totalMinutes = Math.floor(diff / (1000 * 60));
      const days = Math.floor(totalMinutes / (60 * 24));
      const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
      const minutes = totalMinutes % 60;

      setTimeLeft({ days, hours, minutes });
    };

    update();
    const interval = setInterval(update, 60000);
    return () => clearInterval(interval);
  }, []);
  const pad = (n) => String(n).padStart(2, "0");

  return (
    <div className="z-[1000] fixed top-0 flex justify-center items-center w-full">
      <nav
        className={`h-[64px] w-full max-md:h-[70px] flex flex-row items-center justify-between py-4 gap-6 px-14 max-md:p-8 max-[520px]:px-4 max-md:py-6 ${
          pathname === "/" ? "" : ""
        } font-[Manrope] bg-[#E5F0FF] border border-[#ECECEC]`}
      >
        <div className="flex gap-4 items-center justify-start">
          <Link to="/">
            <img
              src={smart_comply_logo_blue}
              alt="Smartcomply"
              className="w-32 max-md:w-28 max-[520px]:w-24"
            />
          </Link>
          <LanguageSwitcher />
        </div>

        <div className="hidden md:flex flex-row items-center gap-10">
          <button onClick={() => scrollToSection("home")}>
            {t("navlinks.home")}
          </button>

          <button onClick={() => scrollToSection("about")}>
            {t("navlinks.about")}
          </button>

          <button onClick={() => scrollToSection("sponsors")}>
            {t("navlinks.sponsors")}
          </button>

          <button onClick={() => scrollToSection("speakers")}>
            {t("navlinks.speakers")}
          </button>

          <button onClick={() => scrollToSection("agenda")}>
            {t("navlinks.agenda")}
          </button>
          <div className="flex items-center gap-1 text-base font-semibold text-black bg-[#CCFF00] px-6 py-2 rounded-md">
            <span>{pad(timeLeft.days)}D</span>
            <span>:</span>
            <span>{pad(timeLeft.hours)}H</span>
            <span>:</span>
            <span>{pad(timeLeft.minutes)}M</span>
          </div>
        </div>

        <div className="block md:hidden">
          <MobileNavbar pathname={pathname} timeLeft={timeLeft} />
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
